import { render, staticRenderFns } from "./Angestelltenliste.vue?vue&type=template&id=44ef74d2"
import script from "./Angestelltenliste.vue?vue&type=script&lang=js"
export * from "./Angestelltenliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports